import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CNUser } from '../models/cnuser';
import { UserDomain } from '../models/custom/userdomain';
import { SNItemFactory } from '../models/snitemfactory';
import { SNUser } from '../models/snuser';
import { BecareService } from './becare.service';
import { ODBService } from './odb.service';

export class UserAccess {
  public id: number;
  public access: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private static instance: UserService = null;
  private accessList: Map<string, UserAccess[]> = new Map();

  public user: SNUser;

  constructor(private becare: BecareService, private factory: SNItemFactory,
              private odb: ODBService) {
    UserService.instance = this;
  }

  public static getInstance(): UserService {
    return UserService.instance;
  }

  set userid(userid: string) { // Used by UserConfigServer to initialize this service
    this.odb.itemById(parseInt(userid, 10)).subscribe(item => {
      this.user = item as SNUser;
      this.access().subscribe();
    });
  }

  search(searchstring: string, userClass?: string, groups?: string[]): Observable<CNUser[]> {
    return new Observable(observer => {
      const params: [string, string][] = [['q', searchstring]];
      if (userClass) {
        params.push(['class', userClass]);
      }
      if (groups) {
        params.push(['groups', JSON.stringify(groups)]);
      }
      this.becare.call('/user/search', params).subscribe(result => {
        if (result.success === true && result.users !== undefined) {
          // Instanciates all doctor items
          const users: CNUser[] = this.factory.itemsFromJson(result.users);
          observer.next(users);
        } else {
          observer.error('error while searching for users');
        }
      }, error => {
        observer.error(error);
      });
    });
  }

  public groups(user: CNUser): Observable<CNUser[]> {
    return this.becare.call('/user/' + user.id + '/groups', [], '', 'get', 'groups', true);
  }

  public domains(user: CNUser): Observable<UserDomain[]> {
    return this.becare.call('/user/' + user.id + '/domains', [], '', 'get', 'domains', true);
  }

  public access(user?: CNUser): Observable<UserAccess[]> {
    const userid = (user) ? user.id : 'current';
    return this.becare.call('/user/' + userid + '/access', [], '', 'get', 'access', true)
      .pipe(map((accessList) => {
        this.accessList.set((user) ? user.id.toString() : 'current', accessList);
        return accessList;
      }));
  }

  public defaultAccess(type: string, user?: CNUser): UserAccess {
    const userId = (user) ? user.id.toString() : 'current';
    if (!this.accessList.has(userId)) {
      return undefined;
    }
    const accessId = userId === 'current' ? this.user.id : parseInt(userId, 10);
    return this.accessList.get(userId).find(access => access.id === accessId);
  }
}
